  <div
    v-if="token_available"
    id="my-superset-container"
    class="card card-outline border-0"
    ref="dashboardContainer"
  ></div>
  <div v-else>
    <div class="card card-outline rounded-2 shadow mt-3">
      <div class="card-body d-flex align-items-center flex-column">
        <i class="bi bi-exclamation-triangle-fill m-2"></i>
        <div class="text-muted">
          The dashboard is currently unavailable. Please try again later.
        </div>
      </div>
    </div>
  </div>